import { gql } from '@apollo/client';

export const GET_USERS = gql`
  query GetUsers(
    $input: UserQueryInput!
    $trainerId: ID
    $subscriptionTier: String
    $searchTerm: String
  ) {
    users(input: $input) {
      _id
      name
      email
      avatarUrl
      workoutSessionCount
      lastWorkoutSessionAt
      createdAt
      trainingPlanSessions {
        _id
        status
        enrolledAt
        completedAt
        completedEvents {
          eventId
        }
        trainingPlanId
        trainingPlan {
          _id
          title
          eventCount
          weekCount
        }
      }
      subscriptions(trainerId: $trainerId) {
        _id
        vendor
        vendorSubscriptionId
        expiresAt
        canceledAt
        trainerId
        tier
      }
    }

    trainer(id: $trainerId) {
      clientMetrics(
        subscriptionTier: $subscriptionTier
        searchTerm: $searchTerm
      ) {
        total
        active
        inactive
        new
      }
    }
  }
`;

export const INVITE_USER = gql`
  mutation InviteUser($input: InviteUserInput!) {
    inviteUser(input: $input) {
      message
    }
  }
`;
